const dt = new Date();

export default {
  id: {
    dbKey: 'id',
    type: 'string',
    displayName: 'ID',
  },
  email: {
    dbKey: 'email',
    type: 'string',
    displayName: 'Email',
    validationRules: [
      value => (!!value || (value && false)) || 'Required.',
      // eslint-disable-next-line func-names
      function (value) {
        const regex = new RegExp('[^\\s@]+@[^\\s@]+\\.[^\\s@]+', 'gi');
        return regex.test(value) || 'Please enter a valid email address';
      },
    ],
  },
  password: {
    dbKey: 'password',
    type: 'string',
    displayName: 'Password',
    validationRules: [
      value => (!!value || (value && false)) || 'Required.',
      // eslint-disable-next-line func-names
      function (value) {
        const regex = new RegExp('^(?=.*[!@#$%^&*-])(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,20}$');
        return regex.test(value) || 'Use 8-20 characters with capital and small letters, numbers and special characters.';
      },
    ],
  },
  timestamp: {
    dbKey: 'timestamp',
    type: 'string',
    displayName: 'Timestamp',
  },
  roles: {
    dbKey: 'roles',
    type: 'array',
    displayName: 'Permissions',
    allItems: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
  },
  customer: {
    dbKey: 'customer',
    type: 'string',
    displayName: 'Customer resource',
  },
  mock: {
    id: '',
    email: '',
    password: '',
    timestamp: dt.toISOString(),
    roles: ['ROLE_USER'],
  },
};
